module.exports = __webpack_public_path__ + "img/numbers.217a3acf.webp";